import register from './index'
import LyRegister from './leyouIndex'
export default [{
    path: '/register',
    name: 'register',
    component: register
},{
    path: '/leyouRegister',
    name:'lyRegister',
    component:LyRegister
},]